import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'statux'

import useWindowSize from '../../hooks/useWindowSize'
import { interpolate } from '../../utils/strings'

export default function RichText (props = {
    className: null,
    html: null,
    style: null
}) {
    if (!props.html
            && !props.children)
        return null

    let richText = null

    const { pathname } = useLocation()

    const history = useHistory()

    const state = useSelector()

    const getOrigin = () => `${window.location.protocol}//${
        window.location.host}`

    const getAnchors = () => richText
        && Array.from(richText.querySelectorAll('a'))

    const getInternalAnchors = () => getAnchors()
        .filter(el => el.href.indexOf(getOrigin()) === 0)

    const getExternalAnchors = () => getAnchors()
        .filter(el => getInternalAnchors().indexOf(el) === -1)

    const onInternalAnchorClick = (e) => {
        e.preventDefault()
        e.stopPropagation()

        history.push(e.target.href
            .replace(getOrigin(), ''))
    }

    const getExternalAnchorIcon = (el) => el
        && el.querySelector('svg.icon-launch')

    const setExternalAnchorIconSize = (el) => {
        const svg = getExternalAnchorIcon(el)

        if (!svg)
            return

        const fontSize = parseFloat(
            window.getComputedStyle(el).fontSize || '0')

        const iconSize = Math.round(fontSize * 0.777778)

        if (svg.clientWidth !== iconSize)
            svg.setAttribute('width', iconSize)

        if (svg.clientHeight !== iconSize)
            svg.setAttribute('height', iconSize)
    }

    const onExternalAnchorRender = (el) => {
        if (!el)
            return

        const isBold = (el.children.length === 1
                && el.children[0].tagName
                    .match(/(b|strong)/i))

        const isItalic = (el.children.length === 1
                && el.children[0].tagName
                    .match(/(i|em)/i))

        if (isBold
                && !el.classList.contains('font-weight-semibold'))
            el.classList.add('font-weight-semibold')

        if (isItalic
                && !el.classList.contains('font-style-italic'))
            el.classList.add('font-style-italic')

        const isMailto = el.href.match(/^mailto:/)

        const isTel = el.href.match(/^tel:/)

        if (!el.getAttribute('rel'))
            el.setAttribute('rel', 'noopener noreferrer')

        if (!el.getAttribute('target'))
            el.setAttribute('target', '_blank')

        if (!el.getAttribute('title'))
            el.setAttribute('title', !isMailto
                    && !isTel
                ? 'Opens in a new tab'
                : `Opens in default ${isMailto
                    ? 'email'
                    : 'telephone'} client`)

        if (!getExternalAnchorIcon(el)
                && !isMailto
                && !isTel) {
            const linkParts = el.innerText
                .trim()
                .split(/\s+/) || ''

            const linkSuffix = linkParts[linkParts.length - 1]

            if (linkSuffix) {
                const svg = document.createElement('svg')
                svg.classList.add('icon-launch')
                svg.innerHTML = '<use xlink:href="#icon-launch"></use>'

                const isLinkSuffixUrl = linkParts.length === 1
                    && el.getAttribute('href') === linkSuffix

                linkParts[linkParts.length - 1] = `<span${
                    !isLinkSuffixUrl ? ' class="text-nowrap"' : ''}>${
                    linkSuffix}${svg.outerHTML}</span>`

                el.innerHTML = linkParts.join(' ')
            }

            setExternalAnchorIconSize(el)
        }

        el.innerHTML = el.innerHTML
            .replace(/\s+/, ' ')
    }

    useEffect(() => {
        getInternalAnchors()
            .forEach((el) => {
                el.removeEventListener('click', onInternalAnchorClick)
                el.addEventListener('click', onInternalAnchorClick)
            })

        getExternalAnchors()
            .forEach((el) => onExternalAnchorRender(el))
    }, [richText, pathname, props.html])

    useEffect(() => {
        getExternalAnchors()
            .forEach(el => setExternalAnchorIconSize(el))
    }, [useWindowSize()])

    let { html } = props

    if (typeof html === 'string')
        html = interpolate(html, state)

    return (
        <div
            className={`rich-text ${props.className || ''}`
                .trim()}
            dangerouslySetInnerHTML={
                !props.children
                    ? { __html: html }
                    : null
            }
            style={props.style || null}
            ref={(ref) => {
                richText = ref
            }}
        >
            {props.children}
        </div>
    )
}
